module.exports = __webpack_public_path__ + "static/media/Fluid.c20719f0.jpg";